import React, { useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import clsx from "clsx";
import { useStyles } from "./AdminSettings.styles";
import PropTypes from "prop-types";
import { UpdateFacilityInfo } from "./updateFacilityInfo";
import EntityRebootButton from "../../../Entities/Modules/EntityRebootButton";

export const AdminSettings = ({ entityId }) => {
    const classes = useStyles();
    const [expanded, setExpanded] = useState(true);

    const toggleAccordion = () => {
        setExpanded(!expanded);
    };

    return (
        <Grid
            container spacing={2}
            className={clsx("facility-panel", classes.panelRoot)}
            style={{ paddingTop: 10, marginBottom: 10, width: "100%" }}
        >
            <Accordion
                className={clsx("accordion", classes.fullWidthAccordion)}
                expanded={expanded}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    onClick={toggleAccordion}
                >
                    <Typography className={clsx("heading", classes.heading)}>
                        Devices
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                            <UpdateFacilityInfo entityId={entityId}/>
                        </Grid>
                        <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                            <EntityRebootButton entityID={entityId} isAdminTab={true}/>
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </Grid>
    );
};

AdminSettings.defaultProps = {
    entityId: PropTypes.string,
};

AdminSettings.propTypes = {
    entityId: PropTypes.string,
};